





























































































import Vue from "vue";
import _ from "lodash";
import { alertError } from "@/util/alert_errors";
import WrappingMenu from "@/components/CartCommon/CatalogDetailAddCartArea/WrappingMenu.vue";


import {
  Item,
  CommonMasterData,
  SelectedWrapping,
  AddToCartParam,
  PreSelectedPanelSku,
  PreSelectedCoffeeSku
} from "@/components/CartCommon/cart";
import { addToCart } from "@/api/cart";
// loading indicator
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// modal
import VueThinModal from "vue-thin-modal";
import "vue-thin-modal/dist/vue-thin-modal.css";
Vue.use(VueThinModal);
// ga
import { sendGAEvent } from "@/util/google_analytics";

interface Catalog {
  id: number;
  name: string;
  imageUrl: string;
  price: number;
  shippingFeeStr: string;
  backordered: boolean;
  backorderedText: string;
  unitsInStock: number;
  infoAboutOption: string;
  e_gift: boolean;
}

export default Vue.extend({
  props: {
    catalog: {
      type: Object as () => Catalog,
      required: true
    },
    preSelectedPanelSku: {
      type: Object as () => PreSelectedPanelSku | null,
      required: false
    },
    preSelectedCoffeeSku: {
      type: Object as () => PreSelectedCoffeeSku | null,
      required: false
    },
    wrappings: {
      type: Array as () => SowExp.Wrapping[],
      required: true
    }
  },
  components: {
    WrappingMenu,
    Loading
  },
  data() {
    // ラッピングのデフォルトは価格0のラッピング
    const selectedWrapping = this.catalog.e_gift ? null : this.wrappings.find(w => w.price == 0)!!;

    return {
      isLoading: false,
      quantityOptions: this.catalog.unitsInStock,
      selectedWrapping: selectedWrapping ? { id: selectedWrapping.id } as SelectedWrapping : null,
      selectedQuantity: 1,
      modalName: `after-cart-added-modal`
    };
  },
  computed: {
    selectedWrappingObject(): SowExp.Wrapping | null {
      let wrappingId = this.selectedWrapping ? this.selectedWrapping.id : null
      return this.wrappings.find(w => w.id == wrappingId)!;
    }
  },
  methods: {
    onWrappingChanged(wrapping: SelectedWrapping) {
      this.selectedWrapping = wrapping;
    },
    // 「カートに入れる」ボタンのハンドラ
    async onAddCartButtonClicked() {
      // todo: 第３引数のラベルは、リニューアル前には「upward」と「downward」と「hover」があった
      // upward: ページ上部のボタン, downward: ページ下部のボタン, hover: ページ下部にスティッキーホバーするボタン
      // 一旦downwardにしておくが、ラベル名を変えたい場合は第３引数を変更すること
      sendGAEvent("CatalogClick", "click", "downward");

      try {
        this.isLoading = true;
        await addToCart({
          catalogId: this.catalog.id,
          quantity: this.selectedQuantity,
          wrapping: this.selectedWrapping,
          preSelectedPanelSku: this.preSelectedPanelSku,
          preSelectedCoffeeSku: this.preSelectedCoffeeSku
        });
        (this as any).$modal.push(this.modalName);
      } catch (e) {
        alertError(e);
      } finally {
        this.isLoading = false;
      }
    },
    // 「買い物を続ける」ボタンのハンドラ
    onContinuePurchaseButtonClicked() {
      (this as any).$modal.pop();
    }
  }
});
